import { Box, Typography, useTheme } from "@mui/material";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import useSWRMutation from "swr/mutation";
import { useAppDispatch } from "../../../../../hooks/useRedux";
import PlusSVG from "../../../../../media/images/icons/plus";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../../redux/features/snackbarSlice";
import { fetcherPost } from "../../../../../services/fetcher";
import { ITicket } from "../../../../../types/ticket";
import TicketCard from "./TicketCard";

export default function TicketsBox() {
  const theme = useTheme();
  const dispatch = useAppDispatch();

  const {
    trigger: getTicketsTrigger,
    data: getTicketsData,
    // isMutating: isGetTicketsTriggerMutating,
  } = useSWRMutation(
    [`/Ticket/Search`, localStorage.getItem("access_token")],
    fetcherPost
  );

  useEffect(() => {
    getTicketsTrigger({
      Filter: [],
      RowsPerPage: 100,
      Sort: [],
      pageNr: 1,
    });
  }, []);

  return (
    <Box
      sx={{
        marginTop: "16px",
      }}
    >
      <Typography
        sx={{
          textAlign: "center",
          fontWeight: "600",
          fontSize: "14px",
          mb: 2,
        }}
      >
        برای ارتباط با پشتیبان بازارگاه می‌توانید درخواست خود را در فرم پرکنید و
        کارشناسان ما در اولین زمان پاسخ درخواست شما را خواهند داد.
      </Typography>
      <Link
        to={"new-ticket"}
        style={{
          marginTop: "16px",
          backgroundColor: theme.palette.success.main,
          justifyContent: "center",
          padding: "16px 8px",
          borderRadius: "16px",
          display: "flex",
          width: "80%",
          margin: "auto",
          gap: "8px",
        }}
      >
        <Box>
          <PlusSVG color={"#fff"} />
        </Box>
        <Typography
          sx={{
            color: "#ffffff",
          }}
        >
          ایجاد درخواست پشتیبانی جدید
        </Typography>
      </Link>

      <Box
        sx={{
          marginTop: "32px",
          //   border: "1px solid gray",
        }}
      >
        <Box
          sx={{
            // border: "1px solid gray",
            marginTop: "8px",
            // overflow: "auto",
            // maxHeight: "calc(100vh - 60px)",
            marginBottom: "16px",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            padding: "8px 8px",
          }}
        >
          {getTicketsData?.data.map((ticketItem: ITicket) => (
            <TicketCard data={ticketItem} />
          ))}
        </Box>
      </Box>
    </Box>
  );
}
